export const dropPresetValueStyle = {
  colorStyle: 'color',
  textStyle: 'text',
  borderStyle: 'border',
  cornerStyle: 'corner',
  spacingStyle: 'spacing',
  buttonStyle: 'button',
};

export const dropPresetNameStyle = {
  colorStyle: 'Color',
  textStyle: 'Text',
  borderStyle: 'Border',
  cornerStyle: 'Corner',
  spacingStyle: 'Spacing',
  buttonStyle: 'Button',
};

export const dropPresetStyleOptions = [
  {
    name: dropPresetNameStyle.colorStyle,
    value: dropPresetValueStyle.colorStyle,
    icon: 'icon icon-color',
  },
  {
    name: dropPresetNameStyle.textStyle,
    value: dropPresetValueStyle.textStyle,
    icon: 'icon icon-text',
  },
  {
    name: dropPresetNameStyle.borderStyle,
    value: dropPresetValueStyle.borderStyle,
    icon: 'icon icon-border-line',
  },
  {
    name: dropPresetNameStyle.cornerStyle,
    value: dropPresetValueStyle.cornerStyle,
    icon: 'icon icon-corner',
  },
  {
    name: dropPresetNameStyle.spacingStyle,
    value: dropPresetValueStyle.spacingStyle,
    icon: 'icon icon-spacing',
  },
  {
    name: dropPresetNameStyle.buttonStyle,
    value: dropPresetValueStyle.buttonStyle,
    icon: 'icon icon-button',
  },
];

export const BorderStyleOptions = [
  {
    name: 'Solid',
    value: 'solid',
  },
  {
    name: 'Dash',
    value: 'dashed',
  },
  {
    name: 'Dot',
    value: 'dotted',
  },
];

export const BorderSegmentOptions = [
  {
    value: 'none',
    icon: {
      url: 'icon icon-decoration-unset',
      position: 'left',
    },
  },
  {
    value: 'square',
    icon: {
      url: 'icon icon-square',
      position: 'center',
    },
  },
  {
    value: 'round',
    icon: {
      url: 'icon icon-round',
      position: 'right',
    },
  },
];

export const presetOptionTypes = {
  color: 'color',
  border: 'border',
  text: 'text',
  corner: 'corner',
  spacing: 'spacing',
  button: 'button',
};

export const colorType = {
  neutralBase: 'neutral_base',
  neutral1: 'neutral_1',
  neutral2: 'neutral_2',
  neutral3: 'neutral_3',
  brandBase: 'brand_base',
  brand1: 'brand_1',
  brand2: 'brand_2',
  brand3: 'brand_3',
  accent1: 'accent_1',
  accent2: 'accent_2',
  accent3: 'accent_3',
  accent4: 'accent_4',
  accent5: 'accent_5',
  accent6: 'accent_6',
  accent7: 'accent_7',
};

export const textTypeScales = [
  { value: '1.067', name: '1.067 - Minor Second' },
  { value: '1.125', name: '1.125 - Major Second' },
  { value: '1.200', name: '1.200 - Minor Third' },
  { value: '1.250', name: '1.250 - Major Third' },
  { value: '1.333', name: '1.333 - Perfect Fourth' },
  { value: '1.414', name: '1.414 - Augmented Fourth' },
  { value: '1.500', name: '1.500 - Perfect Fifth' },
  { value: '1.618', name: '1.618 - Golden Ratio' },
  { value: 'custom', name: 'Custom' },
];

export const advanceSettingTextList = [
  { tag: 'h1', dataSize: 'h1', title: 'Heading 1', fontSize: '1.96rem/32px' },
  { tag: 'h2', dataSize: 'h2', title: 'Heading 2', fontSize: '1.56rem/25px' },
  { tag: 'h3', dataSize: 'h3', title: 'Heading 3', fontSize: '1.25rem/20px' },
  { tag: 'h4', dataSize: 'h4', title: 'Heading 4', fontSize: '1rem/16px' },
  { tag: 'h5', dataSize: 'h5', title: 'Heading 5', fontSize: '0.8rem/12px' },
  { tag: 'h6', dataSize: 'h6', title: 'Heading 6', fontSize: '0.64rem/10px' },
  { tag: 'h6', dataSize: 'para1', title: 'Paragraph 1', fontSize: '1rem/16px' },
  { tag: 'h6', dataSize: 'para2', title: 'Paragraph 2', fontSize: '0.8rem/12px' },
  { tag: 'h6', dataSize: 'para3', title: 'Paragraph 3', fontSize: '0.64rem/10px' },
  { tag: 'h6', dataSize: 'para4', title: 'Paragraph 4', fontSize: '0.512rem/8px' },
];

export const defaultObGlobalStyle = {
  createNewPreset: false,
  featurePromotion: false,
  previewPreset: false,
  previewMode: false,
  previewPresetOB: 1,
  firstViewListPack: false,
  firstSavePreset: false,
  savePreset: false,
  applyPreset: false,
  publicPreset: false,
  firstPublicPreset: false,
  firstApplyPreset: false,
  introducingGlobalStyle: false,
  customizeStyle: false,
  tooltipColorStyle: false,
  tooltipTextStyle: false,
  tooltipBorderStyle: false,
  tooltipCornerStyle: false,
  tooltipSpacingStyle: false,
  tooltipButtonStyle: false,
  tabSetting: false,
};

export const PACK_ATTRS = {
  text: {
    headingFont: 'font-family',
    paragraphFont: 'font-family',
    fontWeight: 'font-weight',
    fontStyle: 'font-style',
    fontSize: 'font-size',
    decoration: 'text-decoration',
    lineHeight: 'line-height',
    letterSpacing: 'letter-spacing',
    // fontColor: "color",
    marginBottom: 'margin-bottom',
  },
  border: {
    color: 'border-color',
    thickness: 'border-width',
    style: 'border-style',
  },
  textButtonSize: {
    headingFont: 'font-family',
    paragraphFont: 'font-family',
    fontWeight: 'font-weight',
    fontStyle: 'font-style',
    fontSize: 'font-size',
    decoration: 'text-decoration',
  },
};

export const SPACING_DEFAULT_NAMES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];

export const COLOR_KEYS_MAP: any = {
  'neutral-color1': 'gf_gs-color1-neutral',
  'neutral-color2': 'gf_gs-color2-neutral',
  'neutral-color3': 'gf_gs-color3-neutral',
  'brand-color1': 'gf_gs-color1-brand',
  'brand-color2': 'gf_gs-color2-brand',
  'brand-color3': 'gf_gs-color3-brand',
  'accent-color1': 'gf_gs-color1-accent',
  'accent-color2': 'gf_gs-color2-accent',
  'accent-color3': 'gf_gs-color3-accent',
  'accent-color4': 'gf_gs-color4-accent',
  'accent-color5': 'gf_gs-color5-accent',
  'accent-color6': 'gf_gs-color6-accent',
  'accent-color7': 'gf_gs-color7-accent',
  'default-black': 'gf_gs-black-default',
  'default-white': 'gf_gs-white-default',
  'default-transparent': 'gf_gs-transparent-default',
};

export const COLOR_KEYS_MAP_STYLE_NAME: any = {
  'brand-color2': 'Brand Color',
  'neutral-color1': 'Color 1',
  'neutral-color2': 'Color 2',
  'neutral-color3': 'Color 3',
  'accent-color1': 'Color 4',
  'accent-color2': 'Color 5',
  'accent-color3': 'Color 6',
  'brand-color1': 'Color 7',
  'brand-color3': 'Color 8',
  'accent-color7': 'Color 9',
  'accent-color4': 'Color 10',
  'accent-color5': 'Color 11',
  'accent-color6': 'Color 12',
  'default-black': 'Black',
  'default-white': 'White',
  'default-transparent': 'Transparent',
};

export const COLOR_KEYS_MAP_ORDERED: any = {
  'brand-color2': '',
  'neutral-color1': '',
  'neutral-color2': '',
  'neutral-color3': '',
  'accent-color1': '',
  'accent-color2': '',
  'accent-color3': '',
  'brand-color1': '',
  'brand-color3': '',
  'accent-color7': '',
  'accent-color4': '',
  'accent-color5': '',
  'accent-color6': '',
};

export const PRICING_LIMIT_PRESET = {
  starter: 1,
  professional: 3,
  trial: 3,
  advanced: 20,
};
